import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const createSms = "/marcom/sms/create";
const createSmsTemplate = "/marcom/smsTemplate/addSms";
const getSmsTemplate = "/marcom/smsTemplate/getSms";
const getSmsConfig = "/marcom/sms/getSmsConfig";
const createSmsConfig = "/marcom/sms/createSmsConfig";
// const GetImage = "/BrainstormUserSettingsApi/GetImages";

export default {
  createSmsCampaign(payload) {
    return Repository.post(`${createSms}`, payload);
  },
  createSmsTemplate(payload) {
    return Repository.post(`${createSmsTemplate}`, payload);
  },
  getSmsTemplate(payload) {
    return Repository.post(`${getSmsTemplate}`, payload);
  },
  getSmsConfig(payload) {
    return Repository.post(`${getSmsConfig}`, payload);
  },
  createSmsConfig(payload) {
    return Repository.post(`${createSmsConfig}`, payload);
  },
};
